import { useEffect } from "react";
import { options } from "../utils/tmdbToken";
import { useDispatch, useSelector } from "react-redux";
import { addToprated } from "../utils/movieSlice";

const useTopRated = () => {
  const dispatch = useDispatch();
  const topratedmovie=useSelector(store=>store.movie.toprated)
  const fetchToprated = async () => {
    const data = await fetch(
      "https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1",
      options
    );
    const json = await data.json();
    dispatch(addToprated(json.results));
  };
  useEffect(() => {
   !topratedmovie && fetchToprated();
  }, []);
};
export default useTopRated;
